export default __webpack_public_path__ + "static/media/chat-17x12.baeb7f8f.svg";